import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const MyComponent = () => {
  const navigate = useNavigate();

  const handleAddClick = () => {
    navigate('/add-instruction'); // Navigate to Instadd.js page
  };

  return (
    <div>
      <Button
        style={{
          backgroundColor: '#004aad',
          borderColor: '#004aad',
          position: 'relative',
          marginLeft: '2130%',
          display: 'flex',
          alignItems: 'center', // Ensures icon and text are aligned properly
          gap: '5px', // Adds spacing between icon and text
          fontSize: '16px' // Correctly placed font size
        }}
        onClick={handleAddClick} // Navigate on click
      >
        Add
      </Button>
    </div>
  );
};

export default MyComponent;
